import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import EventMain from "./EventMain";
import { useCategories } from "../../hooks/useCategories";
import { useEvents } from "../../hooks/useEvents";

const Event = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentPages, setCurrentPages] = useState({});

  const { data: categoryData, isSuccess: isCategorySuccess } = useCategories();

  const currentPage = currentPages[selectedCategory] || 1;

  const {
    data: eventData,
    isSuccess: isEventSuccess,
    isLoading,
  } = useEvents({
    status: "active",
    page: currentPage,
    approvalStatus: "approved",
    category: selectedCategory,
    enabled: selectedCategory !== null,
  });

  useEffect(() => {
    if (isCategorySuccess && categoryData) {
      setCategories(categoryData.data);
      if (categoryData.data.length > 0) {
        setSelectedCategory(categoryData.data[0].value);
      }
    }
  }, [isCategorySuccess, categoryData]);

  useEffect(() => {
    document.title = "Event | Society of Aquaculture Professionals";
  }, []);

  // Events are already sorted by backend (latest year first)
  const events = isEventSuccess ? eventData?.data?.data || [] : [];
  const pagination = isEventSuccess ? eventData?.data?.pagination || {} : {};

  const hasMore = pagination.hasMore || false;
  const canGoPrev = pagination.hasPrev || false;
  const totalPages = pagination.totalPages || 1;
  const totalCount = pagination.totalCount || 0;

  const handleTabClick = (categoryId) => {
    setSelectedCategory(categoryId);
    // Reset to page 1 when switching categories
    setCurrentPages((prev) => ({ ...prev, [categoryId]: 1 }));
  };

  const handleNext = () => {
    if (hasMore && currentPage < totalPages) {
      setCurrentPages((prev) => ({
        ...prev,
        [selectedCategory]: currentPage + 1,
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrev = () => {
    if (canGoPrev && currentPage > 1) {
      setCurrentPages((prev) => ({
        ...prev,
        [selectedCategory]: currentPage - 1,
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Additional navigation functions
  const handlePageJump = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPages((prev) => ({
        ...prev,
        [selectedCategory]: pageNumber,
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleFirstPage = () => {
    handlePageJump(1);
  };

  const handleLastPage = () => {
    handlePageJump(totalPages);
  };

  return (
    <>
      <Header />
      <EventMain
        categories={categories}
        selectedCategory={selectedCategory}
        events={events}
        hasMore={hasMore}
        canGoPrev={canGoPrev}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        isLoading={isLoading}
        onTabClick={handleTabClick}
        onNext={handleNext}
        onPrev={handlePrev}
        onPageJump={handlePageJump}
        onFirstPage={handleFirstPage}
        onLastPage={handleLastPage}
      />
      <Footer />
    </>
  );
};

export default Event;
